import { Wallet, CheckCircle2 } from "lucide-react";
import { API } from "../../lib/api";
import { isIOS } from "../../lib/config";
import { useLang } from "../../lib/i18n";

export const WalletPanel = ({ employee, onDownloaded }) => {
  const { t, lang } = useLang();
  const issued = employee.wallet_issued_at;
  const date = issued && new Date(issued).toLocaleDateString(lang === "ar" ? "ar-SA-u-ca-gregory" : "en-GB");

  return (
    <div className="rounded-3xl border border-slate-200/80 bg-white p-5" data-testid="wallet-panel">
      <p className="text-xs font-bold uppercase tracking-wider text-slate-500">{t("wallet_title")}</p>
      {issued ? (
        <div className="mt-3 flex items-start gap-3" data-testid="wallet-issued">
          <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" />
          <div>
            <p className="text-sm font-semibold text-slate-900">{t("wallet_added")} {date}</p>
            <p className="mt-1 text-xs text-slate-500">{t("wallet_reset_hint")}</p>
          </div>
        </div>
      ) : (
        <>
          <p className="mt-1 text-xs text-slate-400">{t("wallet_once")}</p>
          <a href={`${API}/me/wallet-pass`} onClick={onDownloaded} data-testid="add-to-wallet-button"
            className="btn-press mt-4 flex min-h-[54px] items-center justify-center gap-2 rounded-2xl bg-black px-4 text-sm font-semibold text-white hover:bg-zinc-800">
            <Wallet className="h-5 w-5" /> {t("add_wallet")}
          </a>
          {!isIOS() && <p className="mt-3 text-xs leading-relaxed text-slate-500" data-testid="wallet-ios-note">{t("wallet_ios_only")}</p>}
        </>
      )}
    </div>
  );
};
